export default {
  paginacao(context) {
    context.commit("paginacao");
  },
  resetPaginacao(context) {
    context.commit("resetPaginacao");
  },
  setPaginaAtual(context, pagina) {
    context.commit("setPagina", pagina);
  },
};
